<script>
import {
  registerDockWidget,
  unregisterDockWidget,
  FLOATING_DOCK_ID,
} from '@modules/global/utils/floating-dock-state'

export default {
  name: 'OptionsTourManual',

  mounted() {
    // Portaliza o FAB pro trilho compartilhado (#aawz-floating-dock, em
    // main.vue) em vez do body direto: como é um item de flex normal ali
    // (não mais position:fixed próprio), ele se junta aos outros widgets
    // (Atendimento/Chat-IA) automaticamente, sem gap quando algum vizinho
    // não existe. O trilho em si é position:fixed, então segue imune a
    // shells legados com containing block ancestral (ex.: Carteira Atual,
    // sob left-bar-actions) — mesma imunidade que o body tinha. Estilos
    // scoped seguem aplicando (o atributo data-v viaja com o elemento).
    // Fallback silencioso se o trilho não existir por algum motivo (layout
    // sem main.vue, ex. algum teste) — o botão só não some da árvore local.
    const dock = document.getElementById(FLOATING_DOCK_ID)
    if (this.$el && dock) {
      dock.appendChild(this.$el)
    }
    // Registra no dock — main.vue.hasDockWidgets soma este contador aos 3
    // widgets que ele mesmo monta, pra sempre renderizar o handle de recolher
    // quando este FAB está na tela (ver comentário em floating-dock-state.js).
    registerDockWidget()
  },

  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.remove()
    }
    unregisterDockWidget()
  },

  methods: {
    // FAB de ação única: o clique reabre o tour de novidades. Mantém o MESMO
    // evento `tour` que os consumidores (settings + compliance/crm/consolidador)
    // já escutam — a mudança é só visual/estrutural, não de contrato.
    emitTour() {
      this.$emit('tour')
    },
  },
}
</script>

<template>
  <div class="options-tour-manual">
    <v-btn
      fab
      color="primary"
      class="options-tour-manual__fab az-shadow"
      aria-label="Abrir tour de novidades"
      @click="emitTour"
    >
      <icon-svg name="question" size="30" color="white" />
    </v-btn>
  </div>
</template>

<style lang="sass" scoped>
// Item de flex normal dentro de #aawz-floating-dock (main.vue) — não é mais
// position:fixed/right calibrado à mão. O recolhimento também vem de graça
// via a cascata `.aawz-dock-collapsed .aawz-floating-dock` do layout, já
// que este elemento agora é um descendente DOM real do trilho.
.options-tour-manual__fab.v-btn
  width: 71px
  height: 71px
</style>
